import { Api } from '@coderhouse/common'
import { Course, ICourse } from '@/models/course'
import { Purchase } from '@/models/purchase'
import { CouponResp } from '@/models/coupon'

const { VUE_APP_CH_WWW_API_ENDPOINT } = process.env

async function getPurchase(params: unknown): Promise<Purchase> {
  return await Api.post(`${VUE_APP_CH_WWW_API_ENDPOINT}/v2/purchases/normalize`, params)
}

async function confirmPurchase(params: unknown): Promise<Purchase> {
  return await Api.post(`${VUE_APP_CH_WWW_API_ENDPOINT}/v3/purchases/availableBalance/create/ok`, params)
}

async function getUpsellingCoupon(country: string): Promise<CouponResp> {
  const startDate = new Date().getTime()
  return await Api.get(`${VUE_APP_CH_WWW_API_ENDPOINT}/checkout/upselling-cupon?country=${country}&startDate=${startDate}`)
}

export { getPurchase, confirmPurchase, getUpsellingCoupon }
